// extracted by mini-css-extract-plugin
export default {"ScanLeadsHealth":"psj87Nd6YevbguwsswA9","ScanLeadsHealth__imagebox":"wzxSN9jxbJozmu8lvcRQ","ScanLeadsHealth__image":"FPns1s0PQqY8kK8Al1pP","ScanLeadsHealth__image__line":"XATDyIbvre9ZIQa1iu3K","ScanLeadsHealth__meterbox":"kvMHK4kefc42AB81A06w","ScanLeadsHealth__meter":"RcFPIqMltBwQOpsBviCG","up_down":"HuQSqO1ISjDFt_a6fm7n"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ScanLeadsHealth\":\"psj87Nd6YevbguwsswA9\",\"ScanLeadsHealth__imagebox\":\"wzxSN9jxbJozmu8lvcRQ\",\"ScanLeadsHealth__image\":\"FPns1s0PQqY8kK8Al1pP\",\"ScanLeadsHealth__image__line\":\"XATDyIbvre9ZIQa1iu3K\",\"ScanLeadsHealth__meterbox\":\"kvMHK4kefc42AB81A06w\",\"ScanLeadsHealth__meter\":\"RcFPIqMltBwQOpsBviCG\",\"up_down\":\"HuQSqO1ISjDFt_a6fm7n\"}";
        // 1790170452469
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  